module.exports = __webpack_public_path__ + "img/pending-check-success.e23010d5.svg";